module.exports = __webpack_public_path__ + "media/images/help/twitter_circle_color-7038db7f8f2aa2e895d16b47af4b895f.png";